<ng-container *ngIf="show">
    <span [attr.auto_id]="autoIdMsg">{{ text }}</span>

    <button mat-icon-button (click)="hide()" aria-label="Close" [attr.auto_id]="autoIdClose">
        <mat-icon>close</mat-icon>
    </button>
</ng-container>
